import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, TransitionGroup as _TransitionGroup } from "vue"

const _hoisted_1 = ["href", "name"]
const _hoisted_2 = {
  key: 1,
  class: "_mb-6 gfu-bt--b1"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_title = _resolveComponent("base-title")
  const _component_localize = _resolveComponent("localize")
  const _component_base_image = _resolveComponent("base-image")
  const _component_external_link = _resolveComponent("external-link")
  const _component_base_carousel_navigation = _resolveComponent("base-carousel-navigation")
  const _component_base_carousel = _resolveComponent("base-carousel")
  const _component_box = _resolveComponent("box")

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_base_title, {
      as: "h3",
      level: "h2"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.Resources.PledgeManager.SectionPartnersTitle), 1 /* TEXT */)
      ]),
      _: 1 /* STABLE */
    }),
    ($options.hasLinkInTitle)
      ? (_openBlock(), _createBlock(_component_localize, {
          key: 0,
          tag: "div",
          class: "_mb-6 gfu-bt--b1",
          resource: _ctx.Resources.PledgeManager.SectionPartnersDescription
        }, {
          default: _withCtx(() => [
            _createElementVNode("a", {
              "format-key": "0",
              href: $options.becomeACreatorUrl,
              class: "gfu-link gfu-link--accent",
              name: _ctx.Resources.PledgeManager.SectionPartnersDescriptionLink
            }, _toDisplayString(_ctx.Resources.PledgeManager.SectionPartnersDescriptionLink), 9 /* TEXT, PROPS */, _hoisted_1)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["resource"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.Resources.PledgeManager.SectionPartnersDescription), 1 /* TEXT */)),
    _createVNode(_component_box, null, {
      default: _withCtx(() => [
        _createVNode(_component_base_carousel, {
          autoplay: true,
          items: $props.items,
          class: "gfu-base-carousel",
          onChange: $options.onChange
        }, {
          view: _withCtx(() => [
            _createVNode(_TransitionGroup, {
              name: $options.transitionName,
              tag: "div",
              class: "_flex _ov-h gfu-base-carousel-wrapper"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.slides, (slide) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: slide.name,
                    class: "gfu-1of2 gfu-1of4--m _px-6 _tac"
                  }, [
                    _createVNode(_component_external_link, {
                      href: slide.url,
                      title: slide.name,
                      class: "gfu-embed gfu-embed--1x1"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_base_image, {
                          class: "gfu-embed__item _pa-4",
                          src: slide.imageUrl,
                          alt: slide.name,
                          width: "120",
                          height: "120",
                          loading: "lazy"
                        }, null, 8 /* PROPS */, ["src", "alt"])
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["href", "title"])
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["name"])
          ]),
          nav: _withCtx(({ onNext, onPrev }) => [
            _createVNode(_component_base_carousel_navigation, {
              type: "prev",
              icon: "angle-left",
              class: "gfu-partners-slider-nav--prev",
              onClick: onPrev
            }, null, 8 /* PROPS */, ["onClick"]),
            _createVNode(_component_base_carousel_navigation, {
              type: "next",
              icon: "angle-right",
              class: "gfu-partners-slider-nav--next",
              onClick: onNext
            }, null, 8 /* PROPS */, ["onClick"])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["items", "onChange"])
      ]),
      _: 1 /* STABLE */
    })
  ]))
}